import { Hint } from '@systemeio/ui'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import React, { FC, PropsWithChildren } from 'react'

interface IntegrationProps {
  logo: JSX.Element
  additionalInfo?: JSX.Element
}

export const Integration: FC<PropsWithChildren<IntegrationProps>> = ({
  logo,
  additionalInfo,
  children,
}) => {
  const { paymentIntegrations } = useConnectedPaymentIntegrations()
  return (
    <div
      className={
        '[&>svg]:shrink-0 flex flex-col items-center justify-between gap-5 sm:flex-row md:justify-center lg:justify-between lg:gap-24'
      }
    >
      <div className="flex gap-3">
        <div className={'min-w-[159px]'}>{logo}</div>
        {additionalInfo && <Hint label={additionalInfo} />}
      </div>
      {paymentIntegrations ? (
        children
      ) : (
        <div className={'bg-skeleton-primary w-24 animate-pulse rounded-lg py-3 text-transparent'}>
          .
        </div>
      )}
    </div>
  )
}
